import {
  IFlowyError,
  IRealmAttachment,
  IRealmCatalogOption,
  // IRealmAttachment,
  // IRealmCatalogOption,
  IRealmFilledForm,
  IRealmFormGizmo,
  IRealmGlobal,
  IRealmUserEvent,
  TRealmDataType,
} from '../../types';

interface IParams {
  type: TRealmDataType;
  data: any;
}

const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/;
/**
 * This function 'revives' data from a stringified and parsed Json, right now
 * it's only working with date
 */
function reviver(_: string, value: any) {
  if (typeof value === 'string' && dateFormat.test(value)) {
    return new Date(value);
  }

  return value;
}

const parseRealmToData = ({ type, data }: IParams): any | undefined => {
  if (
    data !== undefined &&
    data !== null &&
    typeof data === 'object' &&
    !Array.isArray(data)
  ) {
    if (type === 'forms') {
      try {
        const formGizmo: IRealmFormGizmo = {
          id: data.id,
          userId: data.userId,
          version: data.version,
          fid: data.fid,
          formGizmo: JSON.parse(data.formGizmoConfig),
        };
        if (!(data.isMain === undefined || data.isMain === null)) {
          formGizmo.isMain = data.isMain;
        }
        return formGizmo;
      } catch (e) {
        const error: IFlowyError = {
          origin: 'database',
          message: 'Data de la forma corrompida',
        };
        throw error;
      }
    } else if (type === 'filledForms') {
      try {
        const filledForm: IRealmFilledForm = {
          id: data.id,
          fid: data.fid,
          userId: data.userId,
          formId: data.formId,
          formVersion: data.formVersion,
          version: data.version,
          savedAt: data.savedAt,

          // Offline flags
          uploaded: data.uploaded,
          draft: data.draft,
          updated: data.updated,

          offlineStatus: data.offlineStatus,
          gizmoData: JSON.parse(data.gizmoData),
        };
        return filledForm;
      } catch (e) {
        const error: IFlowyError = {
          origin: 'database',
          message: 'Data de la forma llena corrompida',
        };
        throw error;
      }
    } else if (type === 'attachments') {
      try {
        const attachment: IRealmAttachment = {
          fid: data.fid,
          path: data.path,
          file: data.file,
          version: data.version,
          offlineStatus: data.offlineStatus,
          formId: data.formId,
          filledFormId: data.filledFormId,
          questionFid: data.questionFid,
          answerIndex: data.answerIndex,

          uploaded: data.uploaded,
          draft: data.draft,
          updated: data.updated,
        };
        return attachment;
      } catch (e) {
        const error: IFlowyError = {
          origin: 'database',
          message: 'Data del attachment corrompida',
        };
        throw error;
      }
    } else if (type === 'userEvents') {
      try {
        const userEvent: IRealmUserEvent = {
          fid: data.fid,
          category: data.category,
          type: data.type,
          userId: data.userId,
          timestamp: data.timestamp,
          timezone: data.timezone,
          uploaded: data.uploaded,
        };
        if (data.data) {
          userEvent['data'] = JSON.parse(data.data, reviver);
        }

        return userEvent;
      } catch (e) {
        const error: IFlowyError = {
          origin: 'database',
          message: 'Data del userEvent corrompida',
        };
        throw error;
      }
    } else if (type === 'globals') {
      try {
        const realmGlobal: IRealmGlobal = {
          fid: data.fid,
          data: JSON.parse(data.data),
        };

        return realmGlobal;
      } catch (e) {
        const error: IFlowyError = {
          origin: 'database',
          message: 'Data de global corrompida',
        };
        throw error;
      }
    } else if (type === 'catalogOptions') {
      try {
        const catalogOption: IRealmCatalogOption = {
          fid: data.fid,
          value: data.value,
          catalogFid: data.catalogFid,
          selected: data.selected,
          parentFid: data.parentFid,
        };
        if (data.extraData) {
          catalogOption.extraData = JSON.parse(data.extraData);
        }
        return catalogOption;
      } catch (e) {
        const error: IFlowyError = {
          origin: 'database',
          message: 'Data del catalogOption corrompida',
        };
        throw error;
      }
    }
  }

  return;
};

export default parseRealmToData;
